import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("loop_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function inr(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return "₹" + n.toLocaleString("en-IN");
}

export function priceLabel(p) {
  if (p.price_display) return p.price_display;
  if (p.price == null) return "Contact for Price";
  const base = inr(p.price);
  return p.listing_type === "rent" ? `${base}/mo` : base;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export const PROPERTY_TYPES = [
  { value: "plot", label: "Plot" },
  { value: "apartment", label: "Apartment" },
  { value: "villa", label: "Villa" },
  { value: "commercial", label: "Commercial" },
  { value: "land", label: "Land" },
  { value: "office", label: "Office" },
  { value: "warehouse", label: "Warehouse" },
  { value: "development_land", label: "Development Land" },
];

export const CITY_STATE = {
  "Mumbai": "Maharashtra",
  "Delhi": "Delhi NCR",
  "Bengaluru": "Karnataka",
  "Hyderabad": "Telangana",
  "Chennai": "Tamil Nadu",
  "Pune": "Maharashtra",
  "Kolkata": "West Bengal",
  "Ahmedabad": "Gujarat",
  "Gurugram": "Haryana",
  "Noida": "Uttar Pradesh",
  "Jaipur": "Rajasthan",
  "Bhubaneswar": "Odisha",
  "Cuttack": "Odisha",
  "Puri": "Odisha",
  "Khordha": "Odisha",
};

export const CITIES = Object.keys(CITY_STATE);

export const FEATURED_CITIES = ["Mumbai", "Delhi", "Bengaluru", "Hyderabad", "Pune", "Chennai", "Kolkata", "Bhubaneswar"];
